import { useTranslation } from "react-i18next";
import ContentInfo from "./contentInfo";

const Content = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="mx-5 mt-4 mb-12">
      <ContentInfo
        title={t("date")}
        value={`${data.get("date")} • ${data.get("time")}`}
      />
      <ContentInfo
        title={t("payment.trace-no")}
        value={data.get("trace_no") === "None" ? "-" : data.get("trace_no")}
      />
    </div>
  );
};
export default Content;
